import React from "react";
import Navigation from "@/components/Navigation";
import PrivacyHero from "@/components/privacy/PrivacyHero";
import PrivacyContent from "@/components/privacy/PrivacyContent";
import PrivacyContact from "@/components/privacy/PrivacyContact";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-cloud-white">
      <Navigation />
      <PrivacyHero />
      <PrivacyContent />
      {/* <PrivacyContact /> */}
      <Footer />
    </div>
  );
};

export default Privacy;
